<template>
  <div class="room-extend-menu-section-contents">
    <RoomChatForm
        v-for="meetingNote in sortedMeetingNoteList"
        :key="meetingNote.meetingNoteId"
        :type="'meetingNote'"
        :section="section"
        :item="itemObj(meetingNote)"
        :menuList="menuList(meetingNote)"
        @click="$emit('onClickItem', meetingNote)"
        @onClickDelete="onClickDelete"
    />
  </div>  
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RoomChatForm from "@/components/Room/Chat/RoomChatForm.vue";
import moment from "moment/moment";

export default {
  name: "RoomMeetingNote",
  components:{
    RoomChatForm,
  },
  props: {
    section: {
      type: String,
      default: 'meetingNote',
    },
  },
  computed: {
    ...mapGetters('meetingNote', [
        'meetingNoteList', 
        'ongoingMeetingNote',
        'isOngoingMeetingNote',
    ]),
    ...mapGetters('user', [
      'getUsername',
    ]),
    sortedMeetingNoteList(){
      return this.meetingNoteList.filter(p => {
        // 정책 추가
        return true;
      }).sort((a, b) => {
        if(a.startDate > b.startDate)
          return -1;
      })
    },
    itemObj(){
      return meetingNote => {
        let content = meetingNote.endDate ? this.$t('extendMenu.meetingNote.write.complete') : this.$t('extendMenu.meetingNote.write.ongoing');
        if(meetingNote.summaryState === 'completed')
          content += this.$t('extendMenu.meetingNote.summary.complete')
        else if(meetingNote.summaryState === 'pending') // TODO 나중에 css로 옮겨야 함
          content += `${this.$t('extendMenu.meetingNote.summary.ongoing')} <svg aria-hidden="true" role="status" class="inline w-4 h-4 mr-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>\n' +
              '    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>\n' +
              '    </svg>`
        else if(meetingNote.summaryState === 'failed')
          content += this.$t('extendMenu.meetingNote.summary.fail')
        
        let obj = {
          ...meetingNote,
          receiveDate: this.getDurationForm(meetingNote),
          content,
          nickname: this.getUsername(meetingNote.userId) || this.$t('extendMenu.notice.leavedUser'),
        }
        
        return obj
      }
    },
    getDurationForm() {
      return meetingNote => {
        if(!meetingNote.endDate)
          return this.getFormedDate(meetingNote.startDate)
        else
          return `${this.getFormedDate(meetingNote.startDate)} ~ ${this.getFormedTime(meetingNote.endDate)}`
      }
    },
    isEnded() {
      return meetingNote => {
        return !!meetingNote.endDate;
      }
    },
    getFormedDate() {
      return date => {
        return moment(date).format('YYYY-MM-DD HH:mm');
      }
    },
    getFormedTime() {
      return date => {
        return moment(date).format('HH:mm');
      }
    },
    menuList() {
      return meetingNote => {
        if(this.isEnded(meetingNote)){
          return [{
            title: this.$t('extendMenu.meetingNote.ai.download'),
            icon: 'openai',
            click: async () => {
              if(this.ongoingMeetingNote?.meetingNoteId === meetingNote.meetingNoteId){
                return this.$alert({
                  text: this.$t('extendMenu.meetingNote.ongoing.download'),
                  onlyOk: true,
                });
              }else{
                let data = await this.getMeetingNote(meetingNote);

                // TODO 회의록 원본 파일 생성 로직 - 데모용 임시
                const rows = data.map(row => ({
                  name: this.getUsername(row.userId) || this.$t('extendMenu.notice.leavedUser'),
                  regDate: row.regDate,
                  duration: row.duration,
                  text: row.text,
                }));

                const XLSX = await import('xlsx');
                const workSheet = XLSX.utils.json_to_sheet(rows);
                XLSX.utils.sheet_add_aoa(workSheet, [[this.$t('common.name'), this.$t('extendMenu.notice.regDate'), this.$t('extendMenu.notice.speak.time'), this.$t('extendMenu.notice.content')]], {origin: "A1"})

                workSheet["!cols"] = [
                  {wch: 20},
                  {wch: 18},
                  {wch: 5},
                  {
                    wch: 100,
                    alignment: {
                      vertical: "center",
                      horizontal: "center",
                      wrapText: true, // any truthy value here
                    },
                  },
                ];

                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, this.$t('extendMenu.meetingNote.title'))

                XLSX.writeFile(workBook, `${moment(meetingNote.startDate).format('YYMMDD_hhmm')}_${this.$t('extendMenu.meetingNote.title')}.xlsx`, { compression: true });
                return;
              }
            }
          },{
            title: this.$t('extendMenu.meetingNote.ai.summary.request'),
            icon: 'openai',
            click: () => {
              if(this.ongoingMeetingNote?.meetingNoteId === meetingNote.meetingNoteId){
                return this.$alert({
                  text: this.$t('extendMenu.meetingNote.ongoing.summary'),
                  onlyOk: true,
                });
              }else{
                let alertText;
                switch (meetingNote.summaryState) {
                  case 'failed':
                  case 'notStarted':
                    return this.$alert({
                      text: this.$t('extendMenu.meetingNote.summary.alert.start'),
                      ok: () => {
                        this.summarizeMeetingNote(meetingNote)
                      },
                    });
                  case 'pending':
                    alertText = this.$t('extendMenu.meetingNote.summary.alert.ongoing')
                    break;
                  case 'completed':
                    alertText = this.$t('extendMenu.meetingNote.summary.alert.complete')
                    break;
                }
                return this.$alert({
                  text: alertText,
                  onlyOk: true,
                });
              }
            }
          },{
            title: this.$t('extendMenu.meetingNote.ai.summary.download.title'),
            icon: 'openai',
            click: async() => {
              if(meetingNote.summaryState === 'completed'){
                let data = await this.getMeetingNoteSummary(meetingNote)
                
                // TODO 데모용 회의록 요약 파일 생성 로직
                const messages = [
                    `${this.$t('extendMenu.meetingNote.meetingDate')}: ${this.getFormedDate(data.startDate)} ~ ${this.getFormedTime(data.endDate)}\n`,
                    `${this.$t('extendMenu.meetingNote.writer')}: ${this.getUsername(data.userId) || this.$t('extendMenu.meetingNote.leavedUser')}\n`,
                    `${this.$t('extendMenu.meetingNote.summary.content')}: ${data.summary}`                    
                ]
                const blob = new Blob(messages, {type: 'text/plain', endings: 'native'});
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                try{
                  a.href = url;
                  a.download = `${moment(meetingNote.startDate).format('YYMMDD_hhmm')}_${this.$t('extendMenu.meetingNote.summaryNote')}.txt`;
                  document.body.append(a);
                  a.click();
                }finally{
                  window.URL.revokeObjectURL(url);
                  a.remove();
                }
                
                return;
              }

              let alertText;
              switch (meetingNote.summaryState) {
                case 'failed':
                  alertText = this.$t('extendMenu.meetingNote.download.fail')
                  break;
                case 'notStarted':
                  alertText = this.$t('extendMenu.meetingNote.download.notStarted')
                  break;
                case 'pending':
                  alertText = this.$t('extendMenu.meetingNote.download.pending')
                  break;
              }
              return this.$alert({
                text: alertText,
                onlyOk: true,
              });
            }
          },]
        } else {
          return [{
            title: this.$t('extendMenu.meetingNote.ai.quit.title'),
            icon: 'openai',
            click: async () => {
              return this.$alert({
                text: this.$t('extendMenu.meetingNote.ai.quit.text'),
                ok: () => {
                  this.stopMeetingNote(meetingNote);
                },
              });              
            }
          },]
        }
      }
    },

  },
  methods: {
    ...mapActions('meetingNote', [
      'summarizeMeetingNote',
      'getMeetingNoteSummary',
      'getMeetingNote',
      'stopMeetingNote',
      'deleteMeetingNote',
    ]),
    onClickDelete(meetingNote) {
      if(!meetingNote.endDate){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.delete.ongoing'),
          ok: () => {
            this.stopMeetingNote(meetingNote);
          },
        })
      }else if(meetingNote.summaryState === 'pending'){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.delete.pending'),
          ok: () => {
            this.deleteMeetingNote(meetingNote);
          },
        })
      } else{
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.delete.text'),
          ok: () => {
            this.deleteMeetingNote(meetingNote);
          },
        })        
      }
    },
  },
}
</script>

<style scoped>

</style>